import { createGradientOrSolid } from 'utils';
import { darken } from '@mui/material';
import styled from 'styled-components';

export const StyledFrame = styled.div`
  background: ${(props: any) => createGradientOrSolid(props.borderColor)};
  padding: 2px;
  border-radius: 8px;
  min-width: 300px;
  width: 100%;
  max-width: 400px;
  margin-bottom: ${(props: any) => (props.isMobileView ? '8px' : '0')};
` as any;

export const StyledSpecialOffer = styled.div`
  height: 145px;
  width: 100%;
  box-sizing: border-box;
  font-family: var(--font-family), Arial;

  .frame {
    height: 100%;
    width: 100%;
    position: relative;
    background: ${(props: any) =>
      props.backgroundColor
        ? createGradientOrSolid(props.backgroundColor)
        : 'rgb(255, 253, 230)'};
    padding: 6px;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    box-shadow: inset 0 -1px 4px #ffffff;

    .price-container {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      position: relative;

      .price-container-text {
        font-size: 12px;
        position: absolute;
        bottom: 12px;
        margin-top: 2px;
        color: white;
        font-weight: 900;
        text-shadow: 0 1px 1px #000;
      }

      .timer {
        left: 10px;
      }

      .quantity {
        right: 10px;
      }
    }

    .badge-wrapper {
      max-height: 18px;
      min-height: calc(15% - 4px);
      position: absolute;
      width: 100%;
      top: -1px;
      height: 14px;

      .middle-badge {
        top: -4px;
        height: 14px;
        width: 69px;
        display: flex;
        align-items: center;
        justify-content: center;

        & > p {
          font-size: 10px;
          font-style: normal;
          font-weight: 600;
          line-height: normal;
          margin-bottom: 0;
        }
      }
    }
  }
` as any;

export const ProductsContainer = styled.div`
  width: 100%;
  height: 90px;
  border-radius: 6px 6px 0 0;
  border: 1px solid;
  border-color: ${(props: any) => darken(props.borderColor || '#000000', 0.3)};
  background-color: rgba(0, 0, 0, 0.5);
  background: ${(props: any) =>
    props.backgroundImage ? `url(${props.backgroundImage})` : ''};
  background-size: cover;
  background-position: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
` as any;

export const Product = styled.div`
  box-sizing: border-box;
  height: 100%;
  max-height: 90px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-right: 8px;

  &:last-child {
    margin-right: 0;
  }

  .communix-products {
    &--image {
      width: 66px;
      height: 66px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;

      .image {
        width: 100%;
        height: auto;
        object-fit: contain;
      }
    }

    &--amount {
      font-size: 18px;
      font-style: normal;
      font-weight: 800;
      line-height: normal;
      text-shadow: 0 1px 1px #000;
      color: ${(props: any) => props.data.textFontColorHex};
    }
  }
` as any;
